<template>
  <section>
    <!-- 统计文字 -->
    <el-row class="total">
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-tickets sicon one"></i>
        <span class="tjContent">
          <div>收入</div>
          <div class="numText one">{{cdata.total.income||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-success sicon two"></i>
        <span class="tjContent">
          <div>计价数</div>
          <div class="numText two">{{cdata.total.num||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-news sicon three"></i>
        <span class="tjContent">
          <div>转化率</div>
          <div class="numText three">{{cdata.total.clickok_per||'0'}}%</div>
        </span>
      </el-card>
    </el-row>
    <el-row class="selectRow">
      <el-col :sm="16" :xs="24">
        <el-row :gutter="10">
          <el-button class="xs24" type="primary" id="yesterday" plain @click="changeDate(1)">昨天</el-button>
          <el-button class="xs24" type="primary" id="seven" plain @click="changeDate(7)">最近7天</el-button>
          <el-date-picker
          	class="xs24"
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="今天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <el-button class="xs24" type="primary" plain @click="oneKey(0)" v-if="dateVal[0]===dateVal[1]">一键分配收入</el-button>
          
          <!--<el-dropdown class="dropdown" @command="placementFilter">
	        <el-button type="normal" class="dropdown">
	          {{pText}}
	          <i class="el-icon-arrow-down el-icon--right"></i>
	        </el-button>
	        <el-dropdown-menu slot="dropdown" class="dropdown-menu">
	          <el-dropdown-item command>所有投放位置</el-dropdown-item>
	          <el-dropdown-item v-for="(v,i) in options" :key="i" :command="v">{{v}}</el-dropdown-item>
	        </el-dropdown-menu>
	      </el-dropdown>-->
	      
	      <el-select class="xs24"  v-model="pText" placeholder="所有投放位置" clearable @change="placementFilter">
			     <el-option
			      v-for="item in options"
			      :key="item"
			      :label="item"
			      :value="item">
			    </el-option>
			  </el-select>
	      
        </el-row>
      </el-col>
      <el-col  :sm="8" :xs="24">
        <div style="float:right;text-align: right;">
          <el-row :gutter="10">
            <el-button class="xs24"  type="primary" round @click="toogleChart">图表</el-button>
            <el-dropdown class="dropdown xs24" @command="themeFilter">
              <el-button type="normal" class="dropdown">
                {{tText}}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" class="dropdown-menu">
                <el-dropdown-item command>所有类型</el-dropdown-item>
                <el-dropdown-item v-for="(v,i) in config" :key="i" :command="v">{{v}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-input
              style="width:170px"
              @clear="getList"
              @keyup.enter.native="search"
              ref="input"
              class="search xs24"
              v-model="pdata.kw"
              clearable
              placeholder="请输入产品名称"
              :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
            ></el-input>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <!-- 图表 -->
    <el-row style="min-width:1200px" v-show="!isChartShow">
      <div id="chart" style="width:100%; height:500px;"></div>
    </el-row>
    <!--列表-->
    <el-table
      class="data"
      :data="cdata.list"
      style="width: 100%;min-width:1200px"
      row-key="creative_id"
      stripe
      :row-class-name="tableRowClassName"
      @expand-change="expands"
    >
      <el-table-column type="expand" prop="name" v-if="dateVal[0]!==dateVal[1]">
        <template slot-scope="s">
          <!-- 折叠 -->
          <el-table :data="s.row.exData" :show-header="false" row-key="creative_id">
            <el-table-column prop="d_date" label="日期" align="center" width="100px"></el-table-column>
            <el-table-column prop="name" label="产品名称" align="center"></el-table-column>
            <el-table-column  prop="placement" label="投放位置" align="center"></el-table-column>
            <el-table-column prop="theme" label="产品分类" align="center"></el-table-column>
            <el-table-column prop="type" label="计价方式" align="center"></el-table-column>
            <el-table-column prop="num" label="计价数" align="center">
              <template slot-scope="s">
                <div :class="s.row.num==0&&s.row.clickok_uv!=0?'noNum':''">{{s.row.num}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="income" label="产品收入" align="center"></el-table-column>
            <el-table-column prop="click_price" label="点击单价" align="center"></el-table-column>
            <el-table-column prop="click_pv" label="点击pv" align="center"></el-table-column>
            <el-table-column prop="click_uv" label="点击uv" align="center"></el-table-column>
            <el-table-column prop="clickok_uv" label="点击成功uv" align="center"></el-table-column>
            <el-table-column prop="unit" label="点击单价 " align="center">
            	
            </el-table-column>
            <el-table-column prop="click_per" label="转化率" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.click_per+'%'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150px">
            	<template slot-scope="scope">
			          <el-button
			            size="mini"
			            type="primary"
			            @click="geng(scope.row)"
			          
			          >更新</el-button>
			          <el-button size="mini" type="primary" @click="jump(scope.row.adminurl)" v-if="(dateVal[0]===dateVal[1])&&scope.row.adminurl!=''">后台</el-button>
			        </template>
            </el-table-column>
          </el-table>
          <!-- 折叠结束 -->
        </template>
      </el-table-column>
      <el-table-column prop="creative_id" label="ID" width="100px" align="center"></el-table-column>
      <el-table-column prop="name" label="产品名称" align="center"></el-table-column>
      <el-table-column  prop="placement" label="投放位置" align="center"></el-table-column>
      <el-table-column prop="theme" label="产品分类" align="center"></el-table-column>
      <el-table-column prop="type" label="计价方式" align="center"></el-table-column>
      <el-table-column
        class-name
        prop="num"
        label="计价数"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.num-0)-(b.num-0)}"
      >
        <template slot-scope="s">
          <div :class="s.row.num==0&&s.row.clickok_uv!=0?'noNum':''">{{s.row.num}}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="income"
        label="收入"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.income-0)-(b.income-0)}"
      ></el-table-column>
      <el-table-column
        prop="click_price"
        label="点击单价"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.click_price-0)-(b.click_price-0)}"
      ></el-table-column>
      <el-table-column
        prop="click_pv"
        label="点击pv"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.click_pv-0)-(b.click_pv-0)}"
      ></el-table-column>
      <el-table-column
        prop="click_uv"
        label="点击uv"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.click_uv-0)-(b.click_uv-0)}"
      ></el-table-column>
      <el-table-column
        prop="clickok_uv"
        label="点击成功uv"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.clickok_uv-0)-(b.clickok_uv-0)}"
      ></el-table-column>
      <el-table-column
        prop="unit"
        label="产品单价 "
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.unit-0)-(b.unit-0)}"
      >
      <template slot-scope="scope">
          <span :class="scope.row.unit!=scope.row.avg_unit?'red':''">{{scope.row.unit}}</span>
        </template>
      
      </el-table-column>
      <el-table-column
        prop="click_per"
        label="转化率"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.click_per-0)-(b.click_per-0)}"
      >
        <template slot-scope="scope">
          <span>{{scope.row.click_per+'%'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作"   width="150px" >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="geng(scope.row)"
            v-if="dateVal[0]===dateVal[1]"
          >更新</el-button>
           <el-button size="mini" type="primary" @click="jump(scope.row.adminurl)" v-if="(dateVal[0]===dateVal[1])&&scope.row.adminurl!=''">后台</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="更新产品数据"
      :visible.sync="editDialog"
      class="dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="choose">
        <el-form-item label="计价单价" :label-width="'120px'">
          <el-input v-model="choose.unit"></el-input>
        </el-form-item>
        <el-form-item label="计价数" :label-width="'120px'">
          <el-input v-model="choose.num" @keyup.enter.native="pupdate"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="pupdate">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="分配收入记录" :visible.sync="logDialog" width="600px">
      <el-table :data="plog" max-height="600">
        <el-table-column label="日期" :width="'150px'">{{this.dateVal[0]}}</el-table-column>
        <el-table-column prop="msg" label="分配记录" :width="'350px'"></el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import { sidata, spupdate, sOneKey, pdataEx } from "../../api/api";
import echarts from "echarts";

export default {
  data() {
    return {
      logDialog: false,
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
      	placement:'',
        page: 1,
        perpage: 20,
        theme: "",
        kw: "",
        app_id: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-01",
        // edate: "2019-04-01"
      },
      tText: "请选择产品类型",
      pText:"请选择产品投放位置",
      plist: [],
      maxPage: 1,
      config: [],
      group: {},
      editDialog: false,
      choose: { index_id: "", unit: "0", num: "0" },

      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 }, //所有数据
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["转化率", "收入", "计价次数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "转化率",
            type: "line",
            smooth: true,
            data: []
          },
          {
            name: "收入",
            type: "line",
            smooth: true,
            data: []
          },
          {
            name: "计价次数",
            type: "line",
            smooth: true,
            data: []
          }
        ],
        color: [
          "#61c0a0",
          "#ee4f54",
          "#8ec1b0",
          "#a6e8ba",
          "#ceead4",
          "#f2e247",
          "#f6e98b",
          "#f77b31",
          "#fc9656",
          "#ec151a",
          "#ee4f54",
          "#ee2159",
          "#fbaaa6"
        ]
      },
      options: [], //投放位置配置

      plog: [] //分配收入日志
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    }
  },
  methods: {
	  placementFilter(s){
	    	this.pText = s == "" ? "请选择产品投放位置" : s;
	    	this.pdata.placement = s;
	    	this.getList();
	   },
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      sidata(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          if (res.data.list!=null&&res.data.list.length > 0) {
            res.data.list.forEach(x => {
              x.exData = [];
            });
          }

          this.cdata = res.data;

          this.option.xAxis.data = res.data.chart.date;
          this.option.series[0].data = res.data.chart.click_per;
          this.option.series[1].data = res.data.chart.income;
          this.option.series[2].data = res.data.chart.num;
          this.drawColumnChart();
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.options = this.$store.config.product_placement;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    drawColumnChart() {
      this.chartColumn = echarts.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter(s) {
      this.tText = s == "" ? "请选择产品类型" : s;
      this.pdata.theme = s;
      this.getList();
    },
    search() {
      // 有问题;
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    geng(s) {
      this.editDialog = true;
      this.choose.index_id = s.id;
      this.choose.unit = s.unit;
      this.choose.num = s.num;
    },
    pupdate() {
      if (this.choose.num) {
        spupdate(this.choose, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.$message({
              message: "更新成功",
              type: "success"
            });
            this.editDialog = false;
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    jump(url) {
      window.open(url, "_blank");
    },
    toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(() => {
        that.chartColumn.resize();
      }, 100);
    },
    oneKey(id = 0) {
      this.$confirm("确定一键更新分配收入?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.diedai(0);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消更新分配"
          });
        });
    },
    diedai(id = 0) {
      if (id == 0) {
        if (!this.logDialog) {
          this.logDialog = true;
        }
        this.plog = [];
      }
      if (this.logDialog) {
        var p = this.dateVal[0].replace(/-/g, "");
        sOneKey(id, p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            if (res.data.index_id != 0) {
              this.plog.unshift(res);
              this.diedai(res.data.index_id);
            } else {
              this.$message({ message: "更新完成", type: "success" });
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },

    tableRowClassName({ row, rowIndex }) {
      if (row.clickok_uv == 0 && row.num != 0) {
        return "warning-row";
      }
      return "";
    },
    expands(r, es) {
      var isshou = false;
      if (es.length > 0) {
        es.forEach(v => {
          if (v.creative_id == r.creative_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = `creative_id=${r.creative_id}&sdate=${this.dateVal[0]}&edate=${
          this.dateVal[1]
        }`;

        pdataEx(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            r.exData = res.data.list;
          }
        });
      }
    }
  },

  mounted() {
    this.getConfig();
    this.getList();
    document.getElementById("yesterday").focus();
  }
};
</script>

<style scoped>
.dialog {
  max-width: 1000px;
  margin: 0 auto;
}
</style>


<style>
.el-table .warning-row,
.el-table--striped .el-table__body tr.warning-row > td {
  background: oldlace;
}
.noNum {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 220, 211);
  line-height: 48px;
}
.data .el-table__expanded-cell[class*="cell"],
.addata .el-table__expanded-cell[class*="cell"],
.cdata .el-table__expanded-cell[class*="cell"] {
  padding: 0;
  padding-left: 48px;
}
span.red{
	color: #FF0000;
}
</style>





// WEBPACK FOOTER //
// pData.vue?1ba69828